import { ReactNode } from 'react';
import CardLayout from '../../../../../shared/components/card/CardLayout';

interface IManageCardTemplateProps {
    title?: string;
    description?: string;
    children: ReactNode;
}

export const ManageCardTemplate = ({ title, description, children }: IManageCardTemplateProps) => {
    return (
        <CardLayout classCard="mb-3">
            <h5 className="mb-0">{title}</h5>
            <div className="text-muted">{description}</div>
            <div>{children}</div>
        </CardLayout>
    );
};
